import React from 'react';

function Header(props) {

    const infos = props.Infos;

    return (
      <div className="header-block">
        <div className="title-block">
          <div className="title">{infos.sdt_main_title}</div>
        </div>
      </div>
    )
}

export default Header;